import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal, Edit, Trash2, UserPlus, MessageSquare } from 'lucide-react';

interface MessageActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  onConnect: () => void;
  onMessage: () => void;
  canEdit: boolean;
  canDelete: boolean;
  canConnect: boolean;
  canMessage: boolean;
}

const MessageActions: React.FC<MessageActionsProps> = ({ 
  onEdit, 
  onDelete, 
  onConnect, 
  onMessage,
  canEdit, 
  canDelete, 
  canConnect,
  canMessage,
}) => {
  if (!canEdit && !canDelete && !canConnect && !canMessage) {
    return null;
  }

  return (
    <div className="opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-7 w-7">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {canMessage && (
            <DropdownMenuItem onClick={onMessage}>
              <MessageSquare className="mr-2 h-4 w-4" />
              <span>Message</span>
            </DropdownMenuItem>
          )}
          {canConnect && (
            <DropdownMenuItem onClick={onConnect}>
              <UserPlus className="mr-2 h-4 w-4" />
              <span>Connect</span>
            </DropdownMenuItem>
          )}
          {canEdit && (
            <DropdownMenuItem onClick={onEdit}>
              <Edit className="mr-2 h-4 w-4" />
              <span>Edit</span>
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem onClick={onDelete} className="text-red-500 focus:bg-red-500 focus:text-white">
              <Trash2 className="mr-2 h-4 w-4" />
              <span>Delete</span>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default MessageActions;